{
  "register-personal-data-page": {
    "buttons": {
      "next": "Další",
      "to-login": "Přihlášení"
    },
    "text": {
      "title": "Registrace",
      "subtitle": "Registrace nového účtu",
      "have-account-question": "Máte již účet?",
      "personal-info": "Vaše osobní údaje",
      "personal-info-hint": "Zadejte prosím své údaje níže"
    }
  }
}
